import React from 'react';

import { Wrapper } from './Block.jsx';
import Name from '../utility/Name.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function ImageComponent(props) {
    const { alt, contentStyle, image, imageStyle, isCropped, link, width, wrapperStyle } = Utilities.parseImageWrapperConfig(props.blockConfig, props);
    const imageUrlFromImage = (image) => {
        let size = 564;
        if (image.width) {
            if (image.width < 1200) {
                if (!isCropped) {
                    size = undefined;
                }
            } else {
                size = 1200
            }
        }
        let transforms;
        if (isCropped) {
            transforms = '';
            if (size) {
                transforms = `h_${size},`;
            }
            transforms += 'c_fill';
        }
        return Utilities.imageUrl(image, size, transforms);
    }
    let imageUrl;
    if (image) {
        imageUrl = imageUrlFromImage(image);
    }
    if (!imageUrl) {
        if (!props.builder) {
            return null;
        }
        if (props.defaultImage) {
            imageUrl = imageUrlFromImage(props.defaultImage);
        }
    }
    let content = (
        <img
            align="center"
            alt={alt || ''}
            className="mcnImage"
            height={isCropped ? width : undefined}
            src={imageUrl}
            style={imageStyle}
            width={width} />
    );
    if (link && link.length > 0) {
        content = (
            <a
                href={link}
                style={{ display: 'block' }}
                target="_blank"
                title="">{content}</a>
        );
    }
    return (
        <Wrapper {...props} className="mcnImageBlock" style={wrapperStyle}>
            <td className="mcnImageBlockInner" valign="top">
                <table
                    align="left"
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="mcnImageContentContainer"
                    style={{ minWidth: '100%' }}
                    width="100%">
                    <tbody>
                        <tr>
                            <td
                                className="mcnImageContent"
                                style={contentStyle}
                                valign="top">
                                {content}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    )
}
const ImageTypeConfig = {
    defaultImage: { extension: 'jpg', height: 532, id: 'mda6928wfib20j4c9sta', width: 800 },
    panel: {
        block: function ({ alt, image }) {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Image',
                        group,
                        name: 'image',
                        type: 'image',
                        value: image
                    },
                    {
                        display: 'Use Cropped Square Image',
                        group,
                        name: 'isCropped',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(true),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Alt Text',
                        fullWidth: true,
                        group,
                        name: 'alt',
                        type: 'text',
                        value: alt
                    },
                    {
                        display: 'Image Link',
                        fullWidth: true,
                        group,
                        name: 'url',
                        type: 'text'
                    }
                ]
            };
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '300',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '9', unit: 'px' },
                            paddingLeft: { value: '18', unit: 'px' },
                            paddingRight: { value: '18', unit: 'px' },
                            paddingTop: { value: '9', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
};
const ImageBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.Image,
        config: {
            block: ImageTypeConfig.panel.block({ image: ImageTypeConfig.defaultImage }),
            layout: ImageTypeConfig.panel.layout()
        },
        display: 'Image',
        group,
        image: 'image.png'
    };
}
const Image = { BlockTypeDefinition: ImageBlockTypeDefinition, Component: ImageComponent, TypeConfig: ImageTypeConfig };

export default Image;